import {
  Battery, BatteryCharging, BatteryFull, BatteryLow, BatteryMedium,
  Wifi, WifiOff, Signal, Cable,
} from 'lucide-react'
import clsx from 'clsx'
import { NETWORK_LABEL, COMMAND_STATUS_CLASSES, COMMAND_STATUS_LABELS } from './mobileUtils'

export function BatteryIndicator({ level, charging, className }) {
  if (level == null) return <span className={clsx('text-gray-400', className)}>—</span>
  const Icon = charging
    ? BatteryCharging
    : level >= 80 ? BatteryFull : level >= 40 ? BatteryMedium : level >= 15 ? BatteryLow : Battery
  const color = level < 15 && !charging ? 'text-red-600' : level < 30 && !charging ? 'text-amber-600' : 'text-gray-700'
  return (
    <span className={clsx('inline-flex items-center gap-1', color, className)} title={charging ? 'Carregando' : 'Bateria'}>
      <Icon className="w-4 h-4" />
      {level}%
    </span>
  )
}

export function NetworkIndicator({ type, signalLevel, ssid, className }) {
  const t = String(type || '').toLowerCase()
  const Icon = t === 'wifi' ? Wifi : t === 'cellular' ? Signal : t === 'ethernet' ? Cable : WifiOff
  const label = NETWORK_LABEL[t] || (type ? type : '—')
  return (
    <span className={clsx('inline-flex items-center gap-1 text-gray-700', className)} title={ssid || label}>
      <Icon className="w-4 h-4" />
      {label}
      {signalLevel != null && t !== 'ethernet' && t !== 'none' && (
        <span className="text-xs text-gray-400">{signalLevel}/4</span>
      )}
    </span>
  )
}

export function CommandStatusBadge({ status }) {
  return (
    <span className={clsx('px-2 py-0.5 rounded-full text-xs font-medium', COMMAND_STATUS_CLASSES[status] || 'bg-gray-100 text-gray-700')}>
      {COMMAND_STATUS_LABELS[status] || status}
    </span>
  )
}
